// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-item[data-v-6841f04f]{cursor:pointer}.tabs[data-v-6841f04f]{max-width:50%}.action-icon[data-v-6841f04f]{max-width:1.5em}", ""]);
// Exports
module.exports = exports;
